// removed by extract-text-webpack-plugin
module.exports = {"bottomBar":"_3ir7S4nyO8R-FpES7sgOn8","viewInside":"_1lqXhWI8qGqEt5U_0YwIK1","starBottom":"_2MbH87-mimPydAzZLy309d","textBottom":"_7CDTcS2KJQGl15uulXmYE","pointView":"Cude1r0DNQkfqovI9UvW2","pointText":"xZC4mYunCdCljC56XITjD","pointExu":"_2KUd-gtvP4iy5XCw3-aqx4","point":"_34_kOeZDNJQdcBnC5Ybp9B","exuPoint":"_2_GbMpfIzbtjGM5vlHFksJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Reward/BottomInfoUser.scss
// module id = 1153
// module chunks = 0